import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '../../api/api.service';
import { IEventDetailApiResponse, IEventsApiResponse, IGetEventsRequest } from '../../../_models/event.model';
import { IAppResponse } from '../../../_interceptors/network-error.model';



@Injectable({
  providedIn: 'root',
})
export class EventService {

  public endpoint: string = "admin";
  private apiService = inject(ApiService);

  getEvents(req: IGetEventsRequest): Observable<IAppResponse<IEventsApiResponse>> {
    let params = new HttpParams()
      .set('page', String(req.page ?? 1))
      .set('limit', String(req.limit ?? 20));

    if (req.status) params = params.set('status', req.status);
    if (req.search?.trim()) params = params.set('search', req.search.trim());

    return this.apiService.get<IEventsApiResponse>({
      Url: `${this.endpoint}/events`,
      Params: params,
    });
  }

  deleteEvent(id: string): Observable<IAppResponse<any>> {
    return this.apiService.delete({
      Url: `${this.endpoint}/events/${id}`,
      Body : ""
    });
  }

  bulkDeleteEvents(eventIds: string[]): Observable<IAppResponse<any>> {
    return this.apiService.post({
      Url: `${this.endpoint}/events/bulk-delete`,
      Body: { eventIds },
    });
  }

  getEventById(id: string): Observable<IAppResponse<IEventDetailApiResponse>> {
  return this.apiService.get<IEventDetailApiResponse>({
    Url: `${this.endpoint}/events/${id}`,
  });
}
}